import React from "react";

import { useRoutes } from "utils/routes";
import PageContent from "ui/PageContent";
import Panel from "ui/Panel";
import PanelSection from "ui/PanelSection";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";
type Props = {
  feature: string;
  additionalText?: React.ReactNode;
  panelOnly?: boolean;
  pluralFeature?: boolean;
  title?: string;
};

const UpgradeRequired: React.FunctionComponent<Props> = ({
  feature,
  additionalText,
  panelOnly,
  pluralFeature,
  title,
}) => {
  const { organizationSubscriptionComparePlans } = useRoutes();
  const currentOrganization = useCurrentOrganization();
  const organizationSlug = currentOrganization?.slug ?? "";

  const panel = (
    <Panel title={title ?? "Upgrade Required"}>
      <PanelSection>
        {additionalText && <p>{additionalText}</p>}
        <strong>{feature}</strong> {(pluralFeature && "are") || "is"} not
        included in your current plan.
      </PanelSection>
      <PanelSection>
        <a
          href={organizationSubscriptionComparePlans(organizationSlug)}
          className="btn btn-success"
        >
          View Upgrade Options
        </a>
      </PanelSection>
    </Panel>
  );

  if (panelOnly) {
    return panel;
  }

  return <PageContent title={feature}>{panel}</PageContent>;
};

export default UpgradeRequired;
